export default __webpack_public_path__ + "static/media/left.35f159ed.txt";